import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import './waba-launch.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaLaunchProps {
  displayName: string;
  mobileNumber: string;
  onBackClick: () => void;
  onContinueClick: () => void;
}

export const WabaLaunch: React.FC<WabaLaunchProps> = ({
  displayName,
  mobileNumber,
  onBackClick,
  onContinueClick,
}) => [
  <div className="waba-launch primary-font-regular">
    <div className="waba-launch-content">
      <img
        src={PNGS.WhatsappBig}
        alt=""
        className="waba-launch-content-image"
      />
      <div className="waba-launch-content-text">
        <span className="waba-launch-content-text-heading primary-font-bold">
          WABA Sign-up launcher
        </span>
        <span className="waba-launch-content-text-description primary-font-regular">
          The launcher will launch the Facebook business portal in a browser
          pop-up and will navigate you through the step by step flow. Click on
          the "Launch" button to start the flow.
        </span>
      </div>
      <div className="waba-launch-content-card">
        <div className="waba-launch-content-card-right">
          <span className="waba-launch-content-card-right-heading primary-font-semibold">
            {displayName}
          </span>
          <span className="waba-launch-content-card-right-text primary-font-regular">
            {'+' + mobileNumber}
          </span>
        </div>
      </div>
    </div>
    <div className="waba-launch-footer">
      <ZoButton
        onClick={onBackClick}
        label={''}
        startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
        className="waba-launch-footer-back"
      />
      <ZoButton
        isLoading={false}
        onClick={onContinueClick}
        label={'Launch Embedded Signup'}
        className="waba-launch-footer-continue"
      />
    </div>
  </div>,
];
